import { api, apiCall } from './client'
import type { ApiResponse } from '../../types'

export interface NurseListItem {
  id: number
  firstName: string
  lastName: string
  email: string
}

export const nursesService = {
  async list(): Promise<ApiResponse<NurseListItem[]>> {
    return apiCall(api.get<ApiResponse<NurseListItem[]>>('/users/nurses'))
  },
}
